/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSheetSelection model module.
 * @module model/AqaSheetSelection
 * @version v0
 */
export default class AqaSheetSelection {
  /**
   * Constructs a new <code>AqaSheetSelection</code>.
   * @alias module:model/AqaSheetSelection
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSheetSelection</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSheetSelection} obj Optional instance to populate.
   * @return {module:model/AqaSheetSelection} The populated <code>AqaSheetSelection</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSheetSelection();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('titleIndex'))
        obj.titleIndex = ApiClient.convertToType(data['titleIndex'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaSheetSelection.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaSheetSelection.prototype.message = undefined;

/**
 * @member {Number} titleIndex
 */
AqaSheetSelection.prototype.titleIndex = undefined;

/**
 * @member {String} title
 */
AqaSheetSelection.prototype.title = undefined;

/**
 * @member {Boolean} successful
 */
AqaSheetSelection.prototype.successful = undefined;

